import { render, staticRenderFns } from "./CasasCobranza.vue?vue&type=template&id=195dc80f&"
import script from "./CasasCobranza.vue?vue&type=script&lang=js&"
export * from "./CasasCobranza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports